module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Cast of Characters")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Alexandria Marie Starr")]), _vm._v(", a.k.a. Lexie–Her perseverance, creative scheming, and impulsive behavior, make her a murderer's worst nightmare, but her lack of fear sometimes makes her even more dangerous to herself. If she doesn't get herself killed, while taking it upon herself to investigate a crime, it isn't for lack of trying.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Stone Van Patten")]), _vm._v("–When this bed and breakfast proprietor married Lexie Starr, he knew what he was getting into, but he loved her too much to turn away and run for the hills, as he was often tempted to do. Stone's patience, and peace of mind, is tested time and time again, until he does the only thing he can think of to protect his wife—he joins her in her quest to catch a killer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Detective Wyatt Johnston")]), _vm._v("–This hulk of a police officer has become a close friend of Lexie and Stone's, which makes him a valuable asset to a determined sleuth who frequently finds herself in need of being rescued. A human eating machine, Wyatt finds a never-ending supply of coffee and sweets at the Alexandria Inn. Could Lexie be feeding him to keep him in her corner?")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Bertha \"Ducky\" Duckworthy")]), _vm._v("–An eccentric enigma, this spunky librarian is ready to retire, but finds a hang up in her retirement plans she hadn't anticipated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Wendy Starr")]), _vm._v("–Lexie's daughter, who makes a living as the assistant to the county coroner, Nate, and makes a valiant effort at trying to keep her mom from sticking her neck on the line nearly every time a body drops, against its will, in Rockdale.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Andy Van Patten")]), _vm._v("–Stone's nephew, who followed in his uncle's footsteps by relocating to the Midwest from South Carolina, is a part-time pilot, part-time rancher, and full-time boyfriend of Lexie's daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Paul Miller")]), _vm._v("–Part-time library employee, and bodybuilding cage-fighter. Lexie's seen mimes who talk more than this man, which makes conversing with him a challenge.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Carolyn Aldrich–When things get too hot at the library, this amicable young lady, and part-time library employee, decides it's time to make a career change.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Tom Melvard")]), _vm._v("–A contract custodian, who is good at cleaning up messes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Angus & Olivia Spurley")]), _vm._v("–Nebraska Senator, and his wife, are paying customers at the Alexandria Inn, who like all the other guests, are spoiled and pampered, well beyond the call of duty, helping make the bed and breakfast a thriving lodging establishment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Detective Clint Spurley")]), _vm._v("–A rookie cop, whose dispassionate, and surly, personality rubs Lexie the wrong way, until she realizes there might be a good reason for his offensive behavior.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Colby and Mrs. Tucker")]), _vm._v("–Director of the county library system, who rarely bites off more than he can chew, and his wisp of a wife, who has the challenging job of keeping her husband full. Lexie can be counted on to make an unforgettable first impression on her new boss.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Quentin Duckworthy")]), _vm._v("–Ducky's husband, loves his wife, but not so much that he can't pursue other interests. Is he a ruthless killer, or just a gentle old man who makes wooden toys for sick children in the hospital?")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Barbara Wells")]), _vm._v("–Is this postal clerk, a buxom blonde, one of the other interests Quentin Duckworthy is pursuing, or someone with her own interests at heart?")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Elroy Traylor")]), _vm._v("–Rockdale City Manager, whose hobbies include land development, bass fishing, and getting under Ducky's skin.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Tina Traylor")]), _vm._v("–Elroy's wealthy wife, whose book collection is worth more than the Rockdale Public Library's, but she's not done collecting yet.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c79263","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section6.vue
// module id = 72
// module chunks = 0